import ErrorPayload from "@/common/utils/error/errorPayload";

export function createErrorPayload(error) {
  let message = null;
  if (error.status) {
    message = "Http error message";
  } else {
    message = "Some internal error message";
  }
  return new ErrorPayload(error, message, error.status || -1);
}
